import Http from "@/libs/axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => {
      return state.list;
    },
  },
  mutations: {
    SET_LIST(state, list) {
      state.list = list;
    },
  },
  actions: {
    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("pa", { params: params })
          .then((response) => {
            commit("SET_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.PA_Rec_date = moment(payload.PA_Rec_date).format("YYYY-MM-DD");
        Http.post("pa", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    getParkingCompoundListByCriteria({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/parking-compound-list-by-criteria", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    getParkingCompoundDetails({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/parking-compound-details", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updateEntry({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/update-parking-compound-entry", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    cancel({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/cancel", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    markPaid({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/mark-paid", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    markUnpaid({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/mark-unpaid", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    markUnused({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("pa/mark-unused", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    export({}, data) {
      return new Promise((resolve, reject) => {
        Http.get("pa/export-data", { params: data })
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    processPaymentUpdate({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/process-payment-update", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrievePostedData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/retrieve-posted-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrieveDiscrepancyData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/retrieve-discrepancy-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    downloadPaDiscrepancyReport({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/generate-discrepancy-report", data, {
          responseType: "arraybuffer",
        })
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updatePaymentReceipt({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/update-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrieveCompoundData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/retrieve-compound", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updateCompound({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/update-compound", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    deleteCompound({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("pa/delete-compound", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    deletePayment({}, id) {
      return new Promise((resolve, reject) => {
        Http.delete(`pa/delete-payment/${id}`)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
  },
};
